import * as ActionTypes from "../actions/actionTypes";
import initialState from "./initialState";

export default (state = initialState.applications, action) => {
  switch (action.type) {
    case ActionTypes.RECEIVE_APPLICATIONS_SNAPSHOT:
      return {
        ...state,
        data: action.applications,
        endBefore: action.endBefore,
        startAfter: action.startAfter
      };
    case ActionTypes.RECEIVE_APPLICATIONS_TOTAL_COUNT_SNAPSHOT:
      return { ...state, totalCount: action.totalCount };
    case ActionTypes.SET_APPLICATIONS_SEARCH_CRITERIA:
      return { ...state, ...action.searchCriteria };
    case ActionTypes.SET_APPLICATIONS_COLUMN_VISIBILITY: {
      return {
        ...state,
        columns: state.columns.map(column => {
          if (column.id === action.column.id) {
            return { ...column, visible: action.column.visible ? false : true };
          }
          return column;
        })
      };
    }
    case ActionTypes.SIGN_OUT_SUCCESS: {
      return initialState.applications;
    }
    default:
      return state;
  }
};
